var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"unauthorized simple"},[_vm._t("header"),_c('main',{staticClass:"flex justify-center flex-wrap"},[_c('Error',{staticClass:"error",attrs:{"code":401,"message":"Du bist aktuell nicht angemeldet.<br>Bitte melde dich an, um diese Seite anzuzeigen."}})],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }